import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../component/form/Grid';
import Label from '../../../component/form/Label';
import ColumnLayout from '../../../component/ColumnLayout';
import LinkButton from '../../../component/form/LinkButton';
import { withRouter } from '../../../util/withRouter';
import { InlineField, InlineHeader } from '../../../component/form/Inline';
import TextField from '../../../component/form/TextField';
import HistoryField from '../../../component/form/HistoryField';
import { getSiteConfig } from '../../../environment';
import { ENQUIRY_TYPES } from '../../quotes/EnquiryConstants';

class Summary extends Component {
    viewRecord = (event, path) => {
        event.preventDefault();
        this.props.history.push(path);
    };

    render() {
        return (
            <Fragment>
                <ColumnLayout>
                    {this.renderFirstColumn()}
                    {this.renderSecondColumn()}
                </ColumnLayout>
            </Fragment>
        );
    }

    renderFirstColumn() {
        return (
            <Grid container spacing={2}>
                {this.renderEnquiries()}
            </Grid>
        );
    }

    renderSecondColumn() {
        return (
            <Grid container spacing={2}>
                {this.renderNotes()}
            </Grid>
        );
    }

    renderEnquiries() {
        const { form, classes } = this.props;
        if (!(form.fields?.ID > 0) || !!form.loading) return null;
        const { Enquiry, Enquiries: PrevEnqs, Quote: MyQuote } = form.fields;
        const hasEnquiry = !!Enquiry || (PrevEnqs && PrevEnqs.length > 0);
        const Enquiries = PrevEnqs.filter(Boolean);
        if (!!Enquiry) {
            Enquiries.push(Enquiry);
        }
        const Quote = MyQuote || Enquiry?.Quotes.find(obj => !!obj.Accepted);
        const enqPath = !!Quote && `/quotes/enquiry/${Quote.Enquiry.LegacyKey}/${Quote.Enquiry.ID}`;
        const latestPrePlan = form.getField('LatestPrePlanForm.ID');
        const formPrePlan =
            getSiteConfig().getPrePlanRegistrationPage +
            '?Type=prearrangement&ID=' +
            form.getField('ID') +
            '&Key=' +
            form.getField('LegacyKey');
        const niceEnqType = myMode => (ENQUIRY_TYPES.find(obj => obj.value === myMode) || { label: '' }).label;
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Related Records</Label>
                </Grid>
                <Grid item xs={12}>
                    <ol className={classes.niceList}>
                        <li>
                            <LinkButton href={formPrePlan} target={'_blank'} text="Prearrangement Registration form" />
                            {!!latestPrePlan && (
                                <small>
                                    &nbsp;
                                    <LinkButton
                                        href={formPrePlan + '&FormID=' + latestPrePlan}
                                        target={'_blank'}
                                        text="View latest submission"
                                    />
                                </small>
                            )}
                        </li>
                        {!!Quote && (
                            <li>
                                Accepted Quote #{Quote.ID}
                                {!!Quote.Enquiry && (
                                    <Fragment>
                                        {' '}
                                        from{' '}
                                        <LinkButton
                                            href={enqPath}
                                            onClick={e => this.viewRecord(e, enqPath)}
                                            text={`${niceEnqType(Quote.Enquiry.EnquiryType)} Enquiry ${
                                                Quote.Enquiry.LegacyKey
                                            }`}
                                        />
                                    </Fragment>
                                )}
                            </li>
                        )}
                        {!!hasEnquiry &&
                            Enquiries.map((enq, i) => {
                                const enqPath = `/quotes/enquiry/${enq.LegacyKey}/${enq.ID}`;
                                const funPath = !!enq.Funeral && `/funeral/${enq.Funeral.LegacyKey}/${enq.Funeral.ID}`;
                                return (
                                    <li key={i}>
                                        <LinkButton
                                            href={enqPath}
                                            onClick={e => this.viewRecord(e, enqPath)}
                                            text={`${niceEnqType(enq.EnquiryType)} Enquiry ${enq.LegacyKey}`}
                                        />
                                        {!!enq.Funeral && (
                                            <Fragment>
                                                {' '}
                                                for{' '}
                                                <LinkButton
                                                    href={funPath}
                                                    onClick={e => this.viewRecord(e, funPath)}
                                                    text={`Funeral ${enq.Funeral.LegacyKey}`}
                                                />
                                            </Fragment>
                                        )}
                                    </li>
                                );
                            })}
                    </ol>
                </Grid>
            </Grid>
        );
    }

    renderNotes() {
        const { form } = this.props;
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <InlineHeader header="Staff Notes" />
                    <InlineField>
                        <TextField
                            placeholder="New notes are written here..."
                            multiline={true}
                            name="BillingNotes"
                            form={form}
                        />
                    </InlineField>
                    <InlineField>
                        <HistoryField value={form.getField('OldBillingNotes')} />
                    </InlineField>
                </Grid>
            </Grid>
        );
    }
}

const styles = ({ spacing }) => ({
    niceList: {
        marginTop: 0,
        marginBottom: 0,
        '&>li': {
            marginTop: spacing(1),
            marginBottom: spacing(1)
        }
    }
});

export default withRouter(withStyles(styles)(Summary));
